export default __webpack_public_path__ + "static/media/sch4_w1024.186297bc.jpg";